import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MediumCircleFilledSvg from "@ant-design/icons-svg/es/asn/MediumCircleFilled";
import AntdIcon from "../components/AntdIcon";
var MediumCircleFilled = function MediumCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MediumCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MediumCircleFilled.displayName = 'MediumCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(MediumCircleFilled);